import {WhitelistEnvKeys} from '../../whitelistEnvKeysType';

// eslint-disable-next-line import/prefer-default-export
export const getEnv = () => {
  return process.env as WhitelistEnvKeys;
};
